import { createContext } from 'react';

import type { XYChartConfigProperties } from '../types/xy-chart.js';

export const XYChartConfigContext = createContext<
  XYChartConfigProperties | string
>('');

/**
 * Provider for the XYChart API config that can be shared across charts
 * @public
 */
export const XYChartConfig = XYChartConfigContext.Provider;
